import { Merge } from 'helpers/typescript';
import Palette from './colors';

export const global = {
  success: {
    background: Palette.green,
    text: Palette.white,
  },
  information: {
    background: Palette.blue,
    text: Palette.white,
  },
  error: {
    background: Palette.red,
    text: Palette.white,
  },
  warning: {
    background: Palette.yellow,
    text: Palette.blueNavy,
  },
  offer: {
    background: Palette.purple,
    text: Palette.white,
  },
  winner: {
    background: Palette.yellowGold,
    text: Palette.white,
  },
  boxShadow: Palette.blueNavy,
  navBar: {
    background: Palette.blueNavy,
    text: Palette.blueSlate,
    highlightedText: Palette.white,
    icon: Palette.blueSlate,
    highlightedIcon: Palette.white,
  },
};

type ThemeBase = {
  theme: 'light' | 'dark';
  background: string;
  surface: string;
  activeSurface: string;
  content: string;
  subContent: string;
  divisions: string;
  link: string;
  defaultLabel: {
    background: string;
    text: string;
  };
  input: {
    background: string;
  };
  icon: {
    primary: string;
    secondary: string;
  };
  banner: {
    background: string;
  };
};

export const darkTheme: ThemeBase = {
  theme: 'dark',
  background: Palette.blueInk,
  surface: Palette.blueNavy,
  activeSurface: Palette.blueDenim,
  content: Palette.white,
  subContent: Palette.blueGrey,
  divisions: Palette.blueDenim,
  link: Palette.blue,
  defaultLabel: {
    background: Palette.blueDenim,
    text: Palette.white,
  },
  input: {
    background: Palette.blueWhite,
  },
  icon: {
    primary: Palette.white,
    secondary: Palette.blueSlate,
  },
  banner: {
    background: Palette.blueDenim,
  },
  ...global,
};

export const lightTheme: ThemeBase = {
  theme: 'light',
  background: Palette.blueWhite,
  surface: Palette.white,
  activeSurface: Palette.blueDenim,
  content: Palette.blueNavy,
  subContent: Palette.blueSlate,
  link: Palette.blue,
  divisions: Palette.blueGrey,
  defaultLabel: {
    background: Palette.blueGrey,
    text: Palette.blueNavy,
  },
  input: {
    background: Palette.white,
  },
  icon: {
    primary: Palette.blueInk,
    secondary: Palette.blueSlate,
  },
  banner: {
    background: Palette.blueNavy,
  },
  ...global,
};

export type Theme = Merge<ThemeBase, typeof global>;
